import React, { useCallback, useState, useEffect } from 'react'
import { Grid, TextField } from '@material-ui/core'
import { SelecionarData, SecaoGenerica } from 'components'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useUsuarioService } from 'hooks/useUsuarioService'
import { useSetorService } from 'hooks/useSetorService'
import { useSolicitacaoExameService } from 'hooks/useSolicitacaoExameService'

export const FormBase = (props) => {
  const { formSolicitacao, solicitacao, arquivos, route } = props
  const setorService = useSetorService()
  const usuarioService = useUsuarioService()
  const solicitacaoExameService = useSolicitacaoExameService()
  const [usuarios, setUsuarios] = useState(null)
  const [processandoUsuarios, setProcessandoUsuarios] = useState(false)
  const [setores, setSetores] = useState(null)
  const [processandoSetores, setProcessandoSetores] = useState(false)
  const [tiposProcedimentos, setTiposProcedimentos] = useState(null)
  const [processandoTiposProcedimentos, setProcessandoTiposProcedimentos] = useState(false)

  const fetchUsuarios = useCallback(async () => {
    const response = await usuarioService.listarUsuariosAsync(setProcessandoUsuarios)
    setUsuarios(response)
  }, [])

  const fetchSetores = useCallback(async () => {
    const response = await setorService.listarSetoresAsync(setProcessandoSetores)
    setSetores(response)
  }, [])

  const fetchTiposProcedimentos = useCallback(async () => {
    const response = await solicitacaoExameService.listarTipoProcedimentosAsync(setProcessandoTiposProcedimentos)
    setTiposProcedimentos(response)
  }, [])

  useEffect(() => {
    if (!usuarios) {
      fetchUsuarios()
    }
    if (!setores) {
      fetchSetores()
    }

    if (!tiposProcedimentos) {
      fetchTiposProcedimentos()
    }
  }, [fetchUsuarios, usuarios, fetchSetores, setores, fetchTiposProcedimentos, tiposProcedimentos])

  useEffect(() => {
    formSolicitacao.setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        arquivos: arquivos || [],
      },
    }))
  }, [arquivos])

  useEffect(() => {
    if (route.editar && solicitacao?.id) {
      formSolicitacao.setFormState((prevState) => ({
        ...prevState,
        values: {
          ...prevState.values,
          identificador_caso_rip: solicitacao.caso?.identificador_caso_rip,
          autReq: solicitacao.autReq,
          autoridadeRequisitanteInput: solicitacao.autoridadeRequisitanteInput,
          setReq: solicitacao.setReq,
          setDest: solicitacao.setDest,
          data: new Date(solicitacao.data),
          tipoProc: solicitacao.tipoProc,
          tipoDocumento: solicitacao.tipoDocumento,
          numeroDocumento: solicitacao.numeroDocumento,
          descricaoDocumento: solicitacao.descricaoDocumento,
          numeroProcedimento: solicitacao.numeroProcedimento,
          indiciado: solicitacao.indiciado,
          boletimOcorrencia: solicitacao.boletimOcorrencia,
          observacoes: solicitacao.observacoes,
          arquivos: solicitacao.arqs.map((arq) => arq.id),
        },
      }))
    }
  }, [solicitacao])

  return (
    <>
      {route.origem === 'REQUISICAO' && (
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item md={3} sm={6} xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                label="Identificador do caso RIP"
                name="identificador_caso_rip"
                onChange={formSolicitacao.handleChange}
                value={formSolicitacao.formState.values.identificador_caso_rip || ''}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      )}

      <Grid item md={6} sm={6} xs={12}>
        <Autocomplete
          value={formSolicitacao.formState.values.autReq || null}
          name="autReq"
          noOptionsText="Sem informações"
          options={usuarios || []}
          onChange={(event, newValue) => {
            formSolicitacao.handleChangeNewValueByNameProperty(event, newValue, 'autReq')
          }}
          getOptionLabel={(option) => `${option.nome?.toUpperCase()} ${option.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
          renderOption={(option) => `${option.nome?.toUpperCase()} ${option.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
          getOptionSelected={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="AUTORIDADE SOLICITANTE"
              required
              placeholder="Selecionar..."
              InputLabelProps={{
                shrink: true,
              }}
              error={formSolicitacao.hasError('autReq')}
              helperText={formSolicitacao.hasError('autReq') ? formSolicitacao.formState.errors.autReq[0] : null}
            />
          )}
        />
      </Grid>
      <Grid item md={6} sm={6} xs={12}>
        <TextField
          value={formSolicitacao.formState.values.autoridadeRequisitanteInput || ''}
          name="autoridadeRequisitanteInput"
          variant="outlined"
          label="OUTRA AUTORIDADE SOLICITANTE"
          fullWidth
          onChange={formSolicitacao.handleChange}
          disabled={formSolicitacao.formState.values.autReq?.nome?.toUpperCase() !== 'OUTRO'}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item md={6} sm={6} xs={12}>
        <Autocomplete
          value={formSolicitacao.formState.values.setReq || null}
          name="setReq"
          noOptionsText="Sem informações"
          options={setores || []}
          onChange={(event, newValue) => {
            formSolicitacao.handleChangeNewValueByNameProperty(event, newValue, 'setReq')
          }}
          getOptionSelected={(option, value) => option.id === value.id}
          getOptionLabel={(option) => `${option.nome.toUpperCase()} - ${option.sigla} / ${option.divisao.regional.nome.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
          renderOption={(option) => `${option.nome.toUpperCase()} - ${option.sigla} / ${option.divisao.regional.nome.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="SETOR SOLICITANTE"
              required
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Selecionar..."
              error={formSolicitacao.hasError('setReq')}
              helperText={formSolicitacao.hasError('setReq') ? formSolicitacao.formState.errors.setReq[0] : null}
            />
          )}
        />
      </Grid>
      <Grid item md={6} sm={6} xs={12}>
        <Autocomplete
          value={formSolicitacao.formState.values.setDest || null}
          name="setDest"
          noOptionsText="Sem informações"
          options={setores || []}
          onChange={(event, newValue) => {
            formSolicitacao.handleChangeNewValueByNameProperty(event, newValue, 'setDest')
          }}
          getOptionSelected={(option, value) => option.id === value.id}
          getOptionLabel={(option) => `${option.nome.toUpperCase()} - ${option.sigla} / ${option.divisao.regional.nome.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
          renderOption={(option) => `${option.nome.toUpperCase()} - ${option.sigla} / ${option.divisao.regional.nome.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="SETOR DESTINO DO EXAME"
              required
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Selecionar..."
              error={formSolicitacao.hasError('setDest')}
              helperText={formSolicitacao.hasError('setDest') ? formSolicitacao.formState.errors.setDest[0] : null}
            />
          )}
        />
      </Grid>

      <Grid item md={6} sm={6} xs={12}>
        <SelecionarData dataBD={formSolicitacao.formState.values.data} callback={(data) => formSolicitacao.handleChangeCampoData('data', data)} label="DATA E HORA DA SOLICITAÇÃO" required shrink md={12} sm={12} xs={12} />
      </Grid>

      <Grid item xs={12}>
        <SecaoGenerica titulo="DADOS DO DOCUMENTO DE SOLICITAÇÃO">
          <Grid container spacing={3}>
            <Grid item md={6} sm={12} xs={12}>
              <Autocomplete
                value={formSolicitacao.formState.values.tipoDocumento || null}
                name="tipoDocumento"
                noOptionsText="Sem informações"
                options={['OFÍCIO', 'MEMORANDO', 'GUIA DE REQUISIÇÃO', 'OUTRO']}
                onChange={(event, newValue) => {
                  formSolicitacao.handleChangeNewValueByNameProperty(event, newValue, 'tipoDocumento')
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Selecionar..."
                    variant="outlined"
                    label="TIPO DO DOCUMENTO DE SOLICITAÇÃO"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                    error={formSolicitacao.hasError('tipoDocumento')}
                    helperText={formSolicitacao.hasError('tipoDocumento') ? formSolicitacao.formState.errors.tipoDocumento[0] : null}
                  />
                )}
              />
            </Grid>

            <Grid item md={6} sm={12} xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                label="NÚMERO DO DOCUMENTO"
                name="numeroDocumento"
                onChange={formSolicitacao.handleChange}
                value={formSolicitacao.formState.values.numeroDocumento || ''}
                InputLabelProps={{
                  shrink: true,
                }}
                required
              />
            </Grid>

            <Grid item md={6} sm={12} xs={12}>
              <Autocomplete
                value={formSolicitacao.formState.values.tipoProc || null}
                name="tipoProc"
                noOptionsText="Sem informações"
                options={tiposProcedimentos || []}
                onChange={(event, newValue) => {
                  formSolicitacao.handleChangeNewValueByNameProperty(event, newValue, 'tipoProc')
                }}
                getOptionLabel={(option) => `${option.nome?.toUpperCase()}`}
                renderOption={(option) => `${option.nome?.toUpperCase()}`}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="TIPO DE PROCEDIMENTO"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    placeholder="Selecionar..."
                    required
                    error={formSolicitacao.hasError('tipoProc')}
                    helperText={formSolicitacao.hasError('tipoProc') ? formSolicitacao.formState.errors.tipoProc[0] : null}
                  />
                )}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <TextField
                id="numeroProcedimento"
                fullWidth
                disabled={formSolicitacao.formState.values.tipoProc?.nome?.toUpperCase() === 'NÃO INFORMADO'}
                variant="outlined"
                label="NÚMERO DE PROCEDIMENTO"
                name="numeroProcedimento"
                onChange={formSolicitacao.handleChange}
                value={formSolicitacao.formState.values.numeroProcedimento || ''}
                InputLabelProps={{
                  shrink: true,
                }}
                required
              />
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                label="INDICIADO"
                name="indiciado"
                onChange={formSolicitacao.handleChange}
                value={formSolicitacao.formState.values.indiciado || ''}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <TextField
                fullWidth
                multiline
                minRows={5}
                required
                variant="outlined"
                label="DESCRIÇÃO DO DOCUMENTO"
                name="descricaoDocumento"
                onChange={formSolicitacao.handleChange}
                value={formSolicitacao.formState.values.descricaoDocumento || ''}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
        </SecaoGenerica>
      </Grid>
    </>
  )
}
